



























import { Component, Vue } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import SectionWrapper from '@/componentsV2/molecules/SectionWrapper/SectionWrapper.vue';
import PerformanceRedemptionOverview from '@/componentsV2/templates/PerformanceRedemptionOverview/PerformanceRedemptionOverview.vue';
import PerformanceRedemptionOvertime from '@/componentsV2/templates/PerformanceRedemptionOvertime/PerformanceRedemptionOvertime.vue';
import PerformanceRedemptionActivity from '@/componentsV2/templates/PerformanceRedemptionActivity/PerformanceRedemptionActivity.vue';

import DateUtils from '@/utils/DateUtils';

@Component({
  components: {
    Page,
    SectionWrapper,
    PerformanceRedemptionOverview,
    PerformanceRedemptionOvertime,
    PerformanceRedemptionActivity
  }
})
export default class Redemptions extends Vue {
  programLaunched = '';

  get tPrefix() {
    return 'performance.redemptions';
  }

  get configSection() {
    return {
      descriptionMaxWidth: '670px',
      padding: '0px',
      background: 'transparent',
      titleFontSize: '24px'
    };
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  mounted() {
    if (
      window.previousRouteName &&
      window.previousRouteName === 'performance-customer-center-detail'
    ) {
      this.setScrollPosition();

      return;
    }

    this.$store.dispatch('performance/RESET_CONFIG', {
      context: 'customerCenter'
    });

    if (this.businessInfo.createdAt)
      this.programLaunched = DateUtils.formattedDate({
        date: this.businessInfo.createdAt,
        applyTimezone: true
      });
  }

  setScrollPosition() {
    const containerScrollElement = document.querySelector(
      '.container-scrollable'
    );

    const scrollYPos = this.$store.getters['performance/getConversionsState']
      .config.scrollYPos;

    if (containerScrollElement) {
      containerScrollElement.scrollTo({
        top: scrollYPos,
        left: 0
      });
    }
  }
}
